import { Panel } from "@/shared/ui";

/**
 * Текстовая секция экрана робота: «О стратегии» (ТЗ §12), «Как он принимает
 * решения», «Почему этот робот дороже» (§4).
 *
 * Один компонент на три блока: они отличаются только заголовком и текстом, а
 * три одинаковые секции подряд в разметке страницы разошлись бы по отступам на
 * первой же правке.
 */
export function TextBlock({ title, body }: { title: string; body: string | null | undefined }) {
  if (!body) return null;
  return (
    <Panel as="section" radius="lg" className="flex flex-col gap-2 p-4">
      <h2 className="text-body font-semibold text-text-primary">{title}</h2>
      <p className="text-caption font-normal text-text-secondary">{body}</p>
    </Panel>
  );
}
